import { createSlice } from '@reduxjs/toolkit';
import sendForReview from '@custom/rtk-apis/radiologistuser/sendforReview';

export const initialState = {
  status:"",
  loading: false,
  success: false,
  error: '',
  msg:""
};

const sendReviewSlice = createSlice({
  name: 'reportSlice',
  initialState,
  reducers: {
    resetReviewState(state) {
      state.status = '';
      state.loading = false;
      state.success = false;
      state.error = '';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(sendForReview.pending, (state) => {
        state.loading = true;
        state.error = '';
      })
      .addCase(sendForReview.fulfilled, (state, { payload }) => {
        state.msg = payload?.msg
        state.loading = false;
        state.status = payload?.initialState;
      })
      .addCase(sendForReview.rejected, (state, { error }) => {
        state.loading = false;
        state.error = error.message || 'Failed to send for review';
      });
  },
});

// Export the reducer
export const { resetReviewState } = sendReviewSlice.actions; // Export the reset action if needed
export default sendReviewSlice.reducer;
